import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ea491ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/svg/Cloud_Error.svg" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/svg/Cloud_Error.svg" }, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "md:container lg:flex md:mx-auto" }
const _hoisted_5 = { class: "overview-item row lg:block items-center lg:w-1/3 lg-boxed-container lg:p-4 self-start z-50 top-0 lg:top-4" }
const _hoisted_6 = { class: "mb-8 hidden lg:block" }
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "flex my-0 items-center" }
const _hoisted_10 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "flex flex-wrap gap-2" }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { class: "lg:w-2/3" }
const _hoisted_16 = { class: "pb-8 container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "geodata-list-handle" }, null, -1))

import AButton from "@/components/Base/AButton";
import DateChange from "@/components/Base/DateChange.vue";
import IonModalNoScrollContent from "@/components/Base/IonModalNoScrollContent.vue";
import SafeArea from "@/components/Base/SafeArea.vue";
import Toolbar from "@/components/Navigation/Toolbar";
import SocketDisconnectedHint from "@/components/Other/SocketDisconnectedHint.vue";
import Skeleton from "@/components/Skeleton.vue";
import BaTabs from "@/components/hzba/BaTabs.vue";
import HzbaSummary from "@/components/hzba/Views/BaSummary.vue";
import HzbaMainView from "@/components/hzba/Views/HzbaMainView";
import AppFloatingIcon from "@/components/v2/App/AppFloatingIcon.vue";
import AppMap from '@/components/v2/App/AppMap.vue';
import GeoDataListModal from "@/components/v2/Map/GeoDataListModal.vue";
import useBestandsaufnahmeUpload from "@/composables/Bestandsaufnahme/useBestandsaufnahmeUpload";
import useDateChangeUtils from "@/composables/Bestandsaufnahme/useDateChangeUtils";
import useOnceBestandsaufnahmeSubpage from "@/composables/Bestandsaufnahme/useOnceBestandsaufnahmeSubpage";
import usePersonChangeUtils from "@/composables/Bestandsaufnahme/usePersonChangeUtils";
import useDoubleModalView from "@/composables/Navigation/useDoubleModalView";
import useToasts from "@/composables/useToasts";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import { Fragenblock } from "@/models/ba/Fragenblock";
import { HzbaStatus, translatedHzbaStatus } from "@/models/ba/interfaces/IBestandsaufnahme";
import User from "@/models/user";
import getLocalization from "@/utilities/get-localization";
import { Network } from "@capacitor/network";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonModal,
  IonPage,
  onIonViewWillEnter,
  onIonViewWillLeave
} from "@ionic/vue";
import { arrowBack, mapOutline } from "ionicons/icons";
import { ComputedRef, computed, onUnmounted, ref, watch } from "vue";
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
import * as turf from "@turf/turf";
import { Map } from "maplibre-gl";
import { getLngLatBounds } from "@/utilities/geo-helper";
import { zoomOnPadding } from "@/styles/map";
import { Monitoring } from "@/utilities/monitoring";

const breakpointDifference = 0.2;


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


const organisationPrefix: ComputedRef<string> = computed(() => {
  const currentUser: User | null = User.query().first();

  return currentUser ? currentUser.organisationPrefix : "";
});

const { t } = useI18n({ useScope: 'global' });
const store = useStore();
const { user, canUpdateBegehungsDate, canUpdateSichtungsDate } = useUser();
const router = useRouter();
const lastRoute = ref();
const mapLibre = ref<Map | null>(null);

const disableDragEvents = ref(false);

const {
  firstModalTemplateRef,
  secondModalTemplateRef,
  isFirstModalOpen,
  isSecondModalOpen,
  openFirstModal,
  hideFirstModal,
  toggleFirstModal,
  openSecondModal,
  hideSecondModal,
  breakpoints,
  initialBreakpointFirstModal,
  initialBreakpointSecondModal,
  currentBreakpointFirstModal,
  currentBreakpointSecondModal,
  onFirstModalBreakpointChange,
  onSecondModalBreakpointChange
} = useDoubleModalView({ startingBreakpointFirstModal: 0.7, startingBreakpointSecondModalRelative: 0.4 });

// the position of the second modal in relation to the map viewport
const currentGeopositionSecondModal = ref(0);
const toast = useToasts();

const isMobileScreen = computed(() => {
  return store.getters["app/isMobile"];
});
const networkStatus = ref();
const featureFlags = computed(() => user.value?.organisation?.featureFlags);
const isSocketConnected = computed(() => {
  return store.getters["app/isSocketConnected"];
});
const currentProject = computed(() => store.state.user.currentUserProject);

const { ba, immobilie, baSubpageName: baSubpage, localSubpage, openChangeStatusAlert } = useOnceBestandsaufnahmeSubpage({ onIonViewWillEnter, onIonViewWillLeave });
const { updateSurvey } = useBestandsaufnahmeUpload();
const {
  isPerformingDatabaseUpdate,
  changedBegehungsdate,
  changedSichtungsdate,
  saveBegehungsDate,
  saveSichtungsDate
} = useDateChangeUtils(ba);
const { openChangePersonAlert } = usePersonChangeUtils();

const featureChangeCounter = ref(0);
const selectedFragenblock = ref<Fragenblock | undefined>();
const parentFragenblock = computed(() => {
  return ba.value?.findSectionByMapGeometryConfig() ?? {} as Fragenblock;
});
const mapFeatures = computed(() => {
  return parentFragenblock.value?.fragenblocks?.filter(item => item.geoJson) ?? [];
});

const showAppMap = computed(() => {
  // for some older templates the map is part of the survey templates and thus mapConfig does not contain a style for surveyMap
  // adding showAppMap as additional flag to not initialize the surveyMap and not show the floating buttons
  return !!featureFlags.value?.surveyMap && !!currentProject.value.mapConfig?.surveyMap?.style;
});

const appMapUpdateCounter = computed(() => {
  return store.state.app.appMapUpdateCounter;
});

const calculateCurrentGeopositionSecondModal = (ionModalWrapper: HTMLElement) => {
  if (ionModalWrapper && mapLibre.value) {
    const absPosition = ionModalWrapper?.getBoundingClientRect()?.top ?? 0;
    const container = mapLibre.value?.getCanvasContainer();
    const position = absPosition - container?.getBoundingClientRect()?.top ?? 0;
    currentGeopositionSecondModal.value = position;
  }
};

const handleMapLoaded = (map: Map) => {
  // @ts-ignore type instantation is excessively deep
  mapLibre.value = map;
};

const showSummary = () => {
  lastRoute.value = baSubpage.value;
  // router.replace(`/ba/${ba.value!.id}/summary`)
  history.replaceState({}, 'title', `/ba/${ba.value!.id}/summary`);
  localSubpage.value = 'summary';
};

const goBackFromSummary = () => {

  const rec = store.state.app.recentRoute;

  // Monitoring.consoleOnly("goBackFromSummary", rec, baSubpage);
  if (baSubpage.value === "summary") {
    if (lastRoute.value) {
      changeTab(lastRoute.value);
      // router.replace(`/ba/${ba.value!.id}/${lastRoute.value}`)
    } else {
      changeTab('');
      // router.replace(`/ba/${ba.value!.id}`)
    }
  } else if (rec.name === 'bas') {
    router.replace("/bas");
  } else if (rec.name === "propertiesMap") {
    router.replace("/properties/map");
  }
  else {
    router.replace("/bas");
  }
  // router.replace(`/ba/${ba.value!.id}/${lastRoute.value}`)
};

const changeTab = (val?: string) => {
  if (val) {
    history.replaceState({}, 'title', `/ba/${ba.value!.id}/${val}`);
  } else {
    history.replaceState({}, 'title', `/ba/${ba.value!.id}`);
  }

  localSubpage.value = val;
};

const openGeodataList = () => {
  selectedFragenblock.value = undefined;
  openSecondModal();
};

const closeGeoDataListModal = () => {
  selectedFragenblock.value = undefined;
  hideSecondModal();
};

const openFragenblockModal = (fragenblock: Fragenblock) => {
  selectedFragenblock.value = fragenblock;
  openSecondModal();
};

const deleteFragenblock = async (fragenblock: Fragenblock) => {
  if (fragenblock) {
    store.dispatch("fragenStore/disconnectAndDeleteFragenblock", { ba: ba.value, fragenblock, parentFragenblock: parentFragenblock.value });
    featureChangeCounter.value += 1;
    selectedFragenblock.value = undefined;
  }
};

const secondModalBreakpointChange = (event: any) => {
  if (event && mapLibre.value) {
    calculateCurrentGeopositionSecondModal(event?.currentTarget?.wrapperEl);
    onSecondModalBreakpointChange(event);
  }
};

const getLatitudeOfMapHeightPlusSecondModalHeight = () => {
  if (mapLibre.value) {
    const centerX = document.documentElement.clientWidth / 2;
    const bottomY = mapLibre.value.getCanvas().getBoundingClientRect().height + currentGeopositionSecondModal.value - 100; // 100px is the height of the second modal
    return mapLibre.value.unproject([centerX, bottomY]);
  }
  return null;
};

const zoomOnPoint = (geoJson: any) => {
  if (mapLibre.value && geoJson) {
    mapLibre.value.jumpTo({
      center: geoJson.geometry.coordinates,
      zoom: 18
    });
  }
};

const zoomOnGeometry = (fragenblock: Fragenblock | void) => {
  if (mapLibre.value && fragenblock) {
    const geoJson = fragenblock.geoJson;
    const [minX, minY, maxX, maxY] = turf.bbox(geoJson) as [number, number, number, number]; // 2D only

    if (geoJson.geometry.type === "Point") {
      // when doing fitBounds on a point, the fetching of the tiles somehow did not work
      // using jumpTo instead for the initial zoom
      zoomOnPoint(geoJson);
    } else {
      const bbox = getLngLatBounds([minX, minY], [maxX, maxY]);
      // first zoom to geometry in map as if the second modal is not open
      mapLibre.value.fitBounds(bbox, {
        padding: zoomOnPadding,
        duration: 0
      });
    }

    if (currentBreakpointFirstModal.value - currentBreakpointSecondModal.value <= breakpointDifference) {
      // the visible part of the map is too small, leave the fitBounds/zoom as is
      return;
    }

    // bbox with newSouth
    const newSouth = getLatitudeOfMapHeightPlusSecondModalHeight();
    if (newSouth) {
      // show geometry in the part of the map that is not covered by the second modal
      const newBbox = getLngLatBounds([minX, newSouth.lat], [maxX, maxY]);
      mapLibre.value.fitBounds(newBbox, {
        padding: zoomOnPadding,
        duration: 500
      });
    }
  }
};

const selectionChangedGeoDataList = (fragenblock: Fragenblock | void) => {
  zoomOnGeometry(fragenblock);
};

const networkListener = Network.addListener("networkStatusChange", (status) => {
  Monitoring.consoleOnly('network status: ', status, 'connection type: ', status.connectionType);
  networkStatus.value = status.connectionType;
});

const onSecondModalPresent = () => {
    const ionModalWrapper = secondModalTemplateRef.value?.$el?.wrapperEl;
    if (ionModalWrapper) {
      calculateCurrentGeopositionSecondModal(ionModalWrapper);
      zoomOnGeometry(selectedFragenblock.value);
    }
};

watch(isSocketConnected, (newVal, oldVal) => {
  if (newVal && oldVal === false) {
    // oldVal === null in initialization
    toast.socketConnected();
  }
});

onUnmounted(() => {
  networkListener?.remove();
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(Toolbar), {
        title: _unref(baSubpage) === 'summary' ? 'Vorschau' : _unref(t)(`${organisationPrefix.value}toolbar.mobile.surveyDetail`) + ` - ${_unref(immobilie) ? _unref(immobilie).externeObjektNr : '...'}`
      }, {
        leading: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "start" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                fill: "clear",
                class: "px-0 -ml-4",
                size: "small",
                onClick: goBackFromSummary
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(arrowBack),
                    size: "large"
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              (networkStatus.value === ('none' || 'undefined') && _unref(baSubpage) !== 'summary')
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: networkStatus.value,
                    "data-cy": "network-status"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        trailing: _withCtx(() => [
          _createVNode(_unref(IonButtons), { slot: "primary" }, {
            default: _withCtx(() => [
              (networkStatus.value === ('none' || 'undefined') && _unref(baSubpage) === 'summary')
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: networkStatus.value,
                    class: "ml-white-text",
                    "data-cy": "network-status"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(baSubpage) !== 'summary')
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 1,
                    class: "ml-white-text",
                    "data-cy": "button-preview",
                    onClick: showSummary
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("hzba.buttons.vorschau")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (_unref(ba))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("hzba.uebersicht.objektTitel")) + " " + _toDisplayString(_unref(immobilie) && _unref(immobilie).externeObjektNr), 1),
                        _hoisted_8,
                        _createTextVNode(_toDisplayString(_unref(getLocalization)(_unref(ba).name)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_9, [
                        _createVNode(DateChange, {
                          modelValue: _unref(changedBegehungsdate),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(changedBegehungsdate) ? (changedBegehungsdate).value = $event : null)),
                          format: "text",
                          title: _ctx.$t(`${organisationPrefix.value}hzba.datum.begehung`),
                          loading: _unref(isPerformingDatabaseUpdate),
                          readonly: !_unref(canUpdateBegehungsDate),
                          onChanged: _unref(saveBegehungsDate)
                        }, null, 8, ["modelValue", "title", "loading", "readonly", "onChanged"])
                      ]),
                      (featureFlags.value?.survey?.showSichtungsdatum)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(["flex items-center", [
                  _unref(canUpdateBegehungsDate) ? 'my-2' : 'my-3'
                ]])
                          }, [
                            _createVNode(DateChange, {
                              modelValue: _unref(changedSichtungsdate),
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(changedSichtungsdate) ? (changedSichtungsdate).value = $event : null)),
                              format: "text",
                              title: _ctx.$t(`${organisationPrefix.value}hzba.datum.sichtung`),
                              loading: _unref(isPerformingDatabaseUpdate),
                              readonly: !_unref(canUpdateSichtungsDate),
                              onChanged: _unref(saveSichtungsDate)
                            }, null, 8, ["modelValue", "title", "loading", "readonly", "onChanged"])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_unref(ba).updatedAt)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("hzba.uebersicht.updateTitel")) + ": " + _toDisplayString(new Date(_unref(ba).updatedAt).toLocaleString("de-De")), 1))
                        : _createCommentVNode("", true),
                      (_unref(ba).updatedBy?.username)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t("hzba.uebersicht.updateVonTitel")) + " " + _toDisplayString(_unref(ba).updatedBy?.username), 1))
                        : _createCommentVNode("", true),
                      (_unref(HzbaStatus)[_unref(ba).status])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("hzba.uebersicht.statusTitel")) + ": " + _toDisplayString(_unref(translatedHzbaStatus)(_unref(ba).status, _unref(t))) + " " + _toDisplayString(_unref(ba).bearbeitenderNutzer?.username ? `(${_unref(ba).bearbeitenderNutzer.username})` : ''), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", null, _toDisplayString(`${_unref(t)('createSurvey.person')}: ${_unref(ba)?.gutachter ? _unref(ba).gutachter.username : _unref(t)('hzba.notAssigned')}`), 1),
                      _createElementVNode("div", _hoisted_13, [
                        (featureFlags.value?.survey?.changeStatus)
                          ? (_openBlock(), _createBlock(_unref(AButton), {
                              key: 0,
                              "btn-tertiary": true,
                              "data-cy": "hzba-status",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(openChangeStatusAlert)(_unref(ba), _unref(t))))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('hzba.updateStatus')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (featureFlags.value?.survey?.changePerson)
                          ? (_openBlock(), _createBlock(_unref(AButton), {
                              key: 1,
                              "btn-tertiary": true,
                              "data-cy": "hzba-person",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(openChangePersonAlert)(_unref(ba))))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('hzba.updatePerson')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(ba).isLocal)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t("hzba.uebersicht.asynchron")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(BaTabs, {
                      "selected-view": _unref(baSubpage),
                      "show-map-button": !!featureFlags.value?.surveyMap && showAppMap.value,
                      onShowSummary: showSummary,
                      onChangeTab: changeTab,
                      onShowMap: _unref(toggleFirstModal)
                    }, null, 8, ["selected-view", "show-map-button", "onShowMap"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(SocketDisconnectedHint, { class: "mt-4 mr-4 ml-4" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)(`${organisationPrefix.value}hzba.noSocketConnection`)), 1)
                        ]),
                        _: 1
                      }),
                      (_unref(ba) && _unref(baSubpage) !== 'summary')
                        ? (_openBlock(), _createBlock(_unref(HzbaMainView), {
                            key: 0,
                            ba: _unref(ba),
                            immobilie: _unref(immobilie),
                            "route-name": _unref(baSubpage)
                          }, null, 8, ["ba", "immobilie", "route-name"]))
                        : (_unref(baSubpage) === 'summary')
                          ? (_openBlock(), _createBlock(HzbaSummary, { key: 1 }))
                          : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock(Skeleton, { key: 1 })),
          (isMobileScreen.value && !!featureFlags.value?.surveyMap && !!_unref(ba) && !!showAppMap.value)
            ? (_openBlock(), _createBlock(AppFloatingIcon, {
                key: 2,
                class: "floating-button",
                "is-visible": !_unref(isFirstModalOpen)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AButton), {
                    type: "button",
                    class: "h-12 w-12",
                    fill: "solid",
                    shape: "round",
                    "data-cy": "btn-map-mobile",
                    "btn-primary": true,
                    onClick: _withModifiers(_unref(openFirstModal), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        icon: _unref(mapOutline),
                        class: "w-6 h-6 map-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["is-visible"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonModal), {
        ref_key: "firstModalTemplateRef",
        ref: firstModalTemplateRef,
        class: "modal-style show-as-background-modal",
        "is-open": _unref(isFirstModalOpen),
        "backdrop-dismiss": false,
        "can-dismiss": true,
        "initial-breakpoint": _unref(initialBreakpointFirstModal),
        breakpoints: _unref(breakpoints),
        "backdrop-breakpoint": 1.0,
        "keep-contents-mounted": true,
        onIonBreakpointDidChange: _unref(onFirstModalBreakpointChange)
      }, {
        default: _withCtx(() => [
          _createVNode(IonModalNoScrollContent, {
            "modal-element": _unref(firstModalTemplateRef),
            "disable-scroll": disableDragEvents.value,
            onClose: _unref(hideFirstModal)
          }, {
            default: _withCtx(() => [
              (showAppMap.value)
                ? (_openBlock(), _createBlock(AppMap, {
                    key: appMapUpdateCounter.value,
                    style: {"height":"100%"},
                    identifier: 'surveyMap',
                    ba: _unref(ba),
                    "map-settings": currentProject.value.mapConfig?.surveyMap,
                    "is-record-geometry-enabled": featureFlags.value?.recordGeometry,
                    "property-location": _unref(immobilie) ? { lat: _unref(immobilie).geolocationLat, lon: _unref(immobilie).geolocationLon } : undefined,
                    "update-features-counter": featureChangeCounter.value,
                    "geo-data-list-active": _unref(isSecondModalOpen),
                    "onList:open": openGeodataList,
                    "onList:close": closeGeoDataListModal,
                    "onList:openItem": openFragenblockModal,
                    "onDrawing:created": openFragenblockModal,
                    "onDrag:start": _cache[4] || (_cache[4] = ($event: any) => (disableDragEvents.value = true)),
                    "onDrag:end": _cache[5] || (_cache[5] = ($event: any) => (disableDragEvents.value = false)),
                    "onMap:loaded": handleMapLoaded
                  }, null, 8, ["ba", "map-settings", "is-record-geometry-enabled", "property-location", "update-features-counter", "geo-data-list-active"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modal-element", "disable-scroll", "onClose"])
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints", "onIonBreakpointDidChange"]),
      _createVNode(_unref(IonModal), {
        ref_key: "secondModalTemplateRef",
        ref: secondModalTemplateRef,
        class: "modal-style show-as-foreground-modal",
        "is-open": _unref(isSecondModalOpen),
        "backdrop-dismiss": false,
        "can-dismiss": true,
        "initial-breakpoint": _unref(initialBreakpointSecondModal),
        breakpoints: _unref(breakpoints),
        "backdrop-breakpoint": 1.0,
        "keep-contents-mounted": true,
        onIonBreakpointDidChange: secondModalBreakpointChange,
        onIonModalDidPresent: onSecondModalPresent
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createVNode(GeoDataListModal, {
            data: mapFeatures.value,
            "preselected-item": selectedFragenblock.value,
            onSelectionChanged: selectionChangedGeoDataList,
            onDismiss: closeGeoDataListModal,
            onDelete: deleteFragenblock
          }, null, 8, ["data", "preselected-item"])
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(SafeArea, { position: "bottom" })
    ]),
    _: 1
  }))
}
}

})